var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":"Reveal password","position":"is-top","type":"is-dark"}},[_c('button',{staticClass:"button",class:{ 'is-loading': _vm.password.state === 'processing' },attrs:{"type":"button"},on:{"click":_vm.encodeDecode}},[_c('b-icon',{attrs:{"icon":_vm.decoded && _vm.viewPassword ? 'eye-slash' : 'eye',"size":"is-small"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }